import { useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts/core';
import { buildEChartsTheme } from '../utils/themebridge';

const THEME_NAME = 'bi-dashboard';

/**
 * Hook that registers an ECharts theme derived from CSS custom properties.
 * Re-registers when the `data-theme` attribute on <html> changes.
 *
 * @returns the theme name to pass to <ReactEChartsCore theme={...} />
 */
export function useEChartsTheme(): string {
  const [revision, setRevision] = useState(0);
  const observerRef = useRef<MutationObserver | null>(null);

  useEffect(() => {
    // Register theme on mount + every revision bump
    const theme = buildEChartsTheme();
    echarts.registerTheme(THEME_NAME, theme);
  }, [revision]);

  useEffect(() => {
    // Watch for data-theme changes on <html>
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && m.attributeName === 'data-theme') {
          setRevision((r) => r + 1);
        }
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme'],
    });

    observerRef.current = observer;
    return () => observer.disconnect();
  }, []);

  return THEME_NAME;
}
